import type { MixpanelEvent } from '../../../tokens';
import type { IconName } from '../../Icons';

export interface TabBarItem {
  id?: string;
  label?: string;
  icon?: IconName;
  indicatorCount?: number;
  /**
   * The route-matching path used to determine whether this tab is "active" (highlighted).
   * Also the default navigation destination when `navigationPath` is not set.
   */
  path?: string;
  /**
   * When set, clicking this tab navigates here instead of `path`.
   * Useful when the route-matching root should stay broad (e.g. a layout base path that
   * matches all child routes) but the click should land on a specific child directly.
   */
  navigationPath?: string;
  mixpanelEvent?: MixpanelEvent;
  children?: TabBarItem[];
  isEditable?: boolean;
  isRemovable?: boolean;
  removeConfirmationText?: string;
}

/** Returns the path that a tab click should navigate to: `navigationPath` if set, else `path`. */
export function getEffectiveNavigationPath(item: TabBarItem): string | undefined {
  return item.navigationPath ?? item.path;
}

export interface SubTabBarAddOption {
  id: string;
  label: string;
  icon?: IconName;
  onSelect: () => void;
}
